import React from "react";
import { MapContainer, TileLayer, GeoJSON, Marker, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const markerIcon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

const FitBounds = ({ geometry }) => {
  const map = useMap();
  React.useEffect(() => {
    if (geometry) {
      const layer = L.geoJSON(geometry);
      map.fitBounds(layer.getBounds(), { padding: [40, 40] });
    }
  }, [geometry, map]);
  return null;
};

export const RouteMap = ({ route }) => {
  return (
    <div
      className="w-full min-h-[300px] h-[360px] rounded-xl overflow-hidden border border-slate-200 shadow-sm"
      data-testid="route-map"
    >
      <MapContainer
        center={[45.1, 15.9]}
        zoom={7}
        style={{ height: "100%", width: "100%" }}
        scrollWheelZoom={false}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; OpenStreetMap'
        />
        {route?.geometry && (
          <>
            <GeoJSON
              key={JSON.stringify(route.geometry.coordinates.length)}
              data={route.geometry}
              style={{ color: "#2563eb", weight: 5, opacity: 0.85 }}
            />
            <FitBounds geometry={route.geometry} />
            {route.waypoints?.map((w, i) => (
              <Marker key={i} position={[w.lat, w.lon]} icon={markerIcon} />
            ))}
          </>
        )}
      </MapContainer>
    </div>
  );
};
